export default {
  "updates": "Updates",
  "changelogs": "Changelogs",
  "all": "All",
  "dashboard": "Dashboard",
  "core": "Core",
  "latest": "Latest",
  "current": "Current",
  "noMatches": "No matches",
  "copyLink": "Copy link",
  "cancel": "Cancel",
  "close": "Close",
  "closeDialog": "Close dialog",
  "ready": "Ready",
  "starting": "Starting",
  "updating": "Updating",
  "restarting": "Restarting",
  "verifying": "Verifying",
  "complete": "Complete",
  "needsAttention": "Needs Attention",
  "failed": "Failed",
  "reinstalled": "Reinstalled",
  "idle": "Idle",
  "confirming": "Confirming",
  "running": "Running",
  "completed": "Completed",
  "cancelled": "Cancelled",
  "systemResponse": "System Response",
  "dashboardUpdate": "Dashboard Update",
  "updateDashboard": "Update dashboard",
  "reloadDashboard": "Reload dashboard",
  "copyLogs": "Copy logs",
  "updateComplete": "Update complete.",
  "updateFailed": "Update failed.",
  "jobCancelled": "Job cancelled.",
  "upToDate": "Up to date",
  "updateAvailable": "Update available",
  "updatesAvailable": "Updates available",
  "unknown": "Unknown",
  "notConfigured": "Not configured",
  "unavailable": "Unavailable",
  "maintenance": "Maintenance",
  "actions": "Actions",
  "update": "Update",
  "pageDescription": "System update status and changelogs",
  "releaseHistory": "Release history",
  "releases_one": "{{displayCount}} release",
  "releases_other": "{{displayCount}} releases",
  "noChangelogs": "No changelogs found",
  "changelogLocation": "Changelogs are available on production installations at",
  "searchChangelogs": "Search changelogs",
  "searchPlaceholder": "Search changelogs...",
  "filterSource": "Filter by source",
  "nextUpdate": "Available in your next update",
  "nextUpdateHelp": "Changelogs for versions newer than the one you have installed, gathered so you can read what an update brings before downloading it.",
  "installedHistory": "Installed & history",
  "backToList": "Back to list",
  "selectChangelog": "Select a changelog to view",
  "chooseEntry": "Choose an entry from the list on the left",
  "changelogFailed": "Failed to load changelog content.",
  "viewRaw": "View raw",
  "fixVersion": "Fix version",
  "fixLibcurl": "Fix rTorrent libcurl",
  "updateQuickbox": "Update QuickBox",
  "fixVersionHelp": "Runs 'qb fix version' to download the current release again and re-run the update. Use it when an update failed or the version looks wrong.",
  "fixLibcurlHelp": "Runs 'qb fix libcurl' to repair libcurl when it is below the version rTorrent needs.",
  "fixPhpSecurity": "Secure PHP",
  "fixPhpSecurityHelp": "Runs 'qb fix php --security' to update PHP for ruTorrent, phpMyAdmin and Nextcloud to the fixed build.",
  "phpSecurity": "PHP security",
  "phpChecked": "Checked {{time}}",
  "phpNotChecked": "PHP has not been checked yet. Secure PHP checks it and updates any app below its security floor.",
  "phpNoApps": "No PHP app is installed.",
  "phpLoadFailed": "PHP status could not be loaded.",
  "phpLoading": "Loading PHP status…",
  "phpMajor": "PHP {{major}}",
  "phpFloor": "Floor {{version}}",
  "phpVersionUnreadable": "Version unreadable",
  "phpAtFloor": "At its security floor",
  "phpBelowFloor": "Below its security floor",
  "phpBelowFloorWarning": "PHP below its security floor",
  "phpSecurityAttention": "PHP security update needed",
  "updateQuickboxHelp": "Runs 'qb update quickbox' to update QuickBox to the latest version.",
  "updateEmby": "Update Emby Server",
  "updateJellyfin": "Update Jellyfin Server",
  "updatePlex": "Update Plex Server",
  "updateMediaHelp": "Runs '{{command}}' to update the {{app}} media server to the latest version.",
  "quickboxMaintenance": "QuickBox Maintenance",
  "escalation": "A QuickBox CLI core update is also pending, so a full update is running - the core is updated first, then the dashboard.",
  "selectOperation": "Select a maintenance operation:",
  "quickboxWarning": "Updating QuickBox may take several minutes and could require service restarts.",
  "preparing": "Preparing update…",
  "progress": "Update progress",
  "step": "Step {{step}} of {{total}}",
  "elapsed": "Elapsed: {{duration}}",
  "activity": "Last activity: {{time}}",
  "stillWorking": "Still working — long-running step in progress",
  "updateFailedExit": "Update failed (exit code {{code}}).",
  "confirmUpdate": "Update the dashboard to the latest version?",
  "confirmUpdateVersion": "Update the dashboard to the latest version ({{version}})?",
  "restartWarning": "The dashboard service will restart during the update. You will temporarily lose connection. The page will automatically reconnect when the update completes.",
  "recovery": "Dashboard is restarting. Waiting for recovery...",
  "verifyingUpdate": "Verifying update...",
  "completeVersion": "Update complete. Version: {{version}}",
  "reinstallUnchanged": "Reinstall complete. Version unchanged ({{version}}).",
  "reinstallNormal": "This is normal when reinstalling the same pre-release version.",
  "unchanged": "Update completed but version unchanged ({{version}}).",
  "checkLogs": "The update may not have been applied. Check logs for errors.",
  "reloadAnyway": "Reload anyway",
  "idleStop": "Waiting for service to stop...",
  "idleDependencies": "Installing dependencies...",
  "idleBuild": "Building application...",
  "idleMigrations": "Applying database migrations...",
  "idleStart": "Starting service...",
  "idleHealth": "Running health checks...",
  "idleWait": "Still waiting... this may take a moment.",
  "idleLong": "Update is taking longer than expected...",
  "latestVersion": "Latest: {{version}}",
  "commit": "Commit: {{commit}}",
  "seconds": "{{value}}s",
  "serviceRestarting": "Service is restarting. Waiting for recovery...",
  "waitingAttempt": "Still waiting for service... (attempt {{attempt}}, ~{{elapsed}}s elapsed)",
  "serviceOnline": "Service is back online. Verifying update...",
  "verified": "Update verified by server. Current: {{version}}",
  "channelUnchanged": "Version unchanged after update ({{channel}} channel).",
  "verifiedUnchanged": "Server verified the update but version did not change.",
  "checkServerLogs": "The update may not have been applied. Check server logs for details.",
  "currentComplete": "Update complete. Current: {{version}}",
  "expectedChannel": "Version unchanged ({{version}}). This is expected on the {{channel}} channel when the latest version is already installed.",
  "centralUnavailable": "Central was unreachable, so update status could not be confirmed.",
  "preReleaseDone": "Version unchanged ({{version}}). Pre-release reinstall completed.",
  "reauthenticate": "Service restarted successfully. Please reload to re-authenticate.",
  "jobSuccessRestart": "Job completed successfully. Service will restart...",
  "noOutput": "No output received for 30s. Checking service status...",
  "jobAccepted": "Update accepted (job: {{jobId}}). Connecting to output stream...",
  "triggered": "Update triggered. Connecting to output stream...",
  "restartTimeout": "Timed out waiting for service to restart. Check server logs.",
  "jobFailed": "Update job failed",
  "jobFailedDetail": "Job failed: {{error}}",
  "startFailed": "Failed to start update.",
  "networkError": "Network error",
  "nonJson": "Non-JSON response from server (HTTP {{status}}). {{detail}}",
  "nonJsonTimeout": "Non-JSON response from server (HTTP {{status}}). The server or proxy may have timed out.",
  "updates.feedback.helperMissing": "Dashboard update helper not found at {{path}}. Ensure v4-dashboard ops helpers are installed.",
  "updates.feedback.helperPrivileges": "Dashboard update helper requires elevated privileges. Ensure the sudoers entry is configured.",
  "updates.feedback.demo": "This action is not available in demo mode. Get QuickBox Pro for full access.",
  "updates.feedback.credentialsRead": "Failed to read API credentials from database.",
  "updates.feedback.credentialsMissing": "Central API credentials not configured. Set api_key and api_instance in system settings.",
  "updates.feedback.startFailed": "Failed to start dashboard update.",
  "updates.feedback.started": "Dashboard update started.",
  "updates.feedback.commandTimeout": "Command timed out after {{timeout}}ms",
  "updates.feedback.createDirectory": "Failed to create state directory {{path}}: {{detail}}",
  "updates.feedback.writeState": "Failed to write job state file {{path}}: {{detail}}",
  "updates.feedback.verifyState": "Job state file verification failed: {{detail}}",
  "updates.feedback.aborted": "Aborted by user",
  "updates.feedback.versionUnchanged": "Version unchanged: buildInfo commit {{preCommit}} -> {{postCommit}}, version {{preVersion}} -> {{postVersion}}, version file {{preFile}} -> {{postFile}}, builtAt {{preBuiltAt}} -> {{postBuiltAt}} (fileAppeared={{fileAppeared}}, becameKnown={{becameKnown}}, builtAtChanged={{builtAtChanged}})",
  "updates.feedback.adminRequired": "Admin privileges required.",
  "updates.feedback.coreFirst": "QuickBox CLI core is behind. Running the full update (core-first); the dashboard updates within that pipeline.",
  "updates.feedback.initialize": "Failed to initialize update job: {{detail}}",
  "updates.feedback.queued": "Dashboard update queued. Connect to the stream endpoint for progress.",
  "updates.feedback.unknownTrigger": "Unknown error in update trigger",
  "updates.feedback.restarting": "Service restarting (simulated)",
  "updates.feedback.noJob": "No update job found.",
  "updates.feedback.waiting": "Waiting for update to begin... (log: {{path}})",
  "updates.feedback.simulated": "Simulated update started ({{duration}}s, reinstall={{reinstall}}, restart={{restart}}, downtime={{downtime}}s).",
  "updates.feedback.stubbed": "Stubbed dashboard_latest_version = \"{{version}}\". The UI should now show \"Update available\".",
  "updates.feedback.stubFailed": "Failed to stub version: {{detail}}",
  "updates.feedback.clearedStub": "Cleared stub. Set dashboard_latest_version = \"{{version}}\" (matches current). UI should show \"Up to date\".",
  "updates.feedback.clearStubFailed": "Failed to clear stub: {{detail}}",
  "updates.feedback.invalidJob": "Invalid job ID",
  "updates.feedback.invalidBody": "Invalid request body",
  "updates.feedback.noActiveJob": "No active update job found",
  "updates.feedback.invalidAction": "Invalid action. Must be 'fix_version', 'fix_libcurl', 'fix_php_security', 'update_quickbox', 'update_emby', 'update_jellyfin', or 'update_plex'.",
  "updates.feedback.alreadyRunning": "A QuickBox operation is already in progress.",
  "updates.feedback.systemdFailed": "[error] systemd-run failed (exit {{code}}): {{detail}}",
  "updates.feedback.recovered": "[recovered] Update unit finished before v4 restarted — exit status unavailable; check system journal.",
  "updates.feedback.libcurlNoFixedBuild": "libcurl is below the version rTorrent needs, and no fixed build is published for this system yet. Nothing was changed.",
  "updates.feedback.libcurlUnreadable": "The installed libcurl version could not be read, so nothing was changed.",
  "updates.feedback.libcurlFixFailed": "The libcurl repair was attempted and did not complete. rTorrent may still be using the old libcurl; check the output above.",
  "updates.feedback.phpUnreadable": "The installed PHP version could not be read, so nothing was changed.",
  "updates.feedback.phpNoFixedBuild": "PHP is below its security floor, and no fixed build is published for this system yet. Nothing was changed.",
  "updates.feedback.phpFixFailed": "The PHP security update was attempted and did not complete. PHP may still be below its security floor; check the output above.",
  "updates.feedback.abortMessageLimit": "Message must be 500 characters or fewer",
  "updates.feedback.validationRequired": "{{field}} is required.",
  "updates.feedback.validationType": "{{field}} must be a {{type}}."
} as const;
